import { c as _c } from "react/compiler-runtime";
import type React from 'react';
const ContainerBox = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <section className="fp-auth-enter relative flex w-full max-w-[400px] flex-col gap-6 rounded-2xl border border-tertiary bg-primary p-6 @md:p-8">{children}</section>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ContainerBox;